var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{ref:"mde"})
}
var staticRenderFns = []

export { render, staticRenderFns }